// Imports

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PICKUP_STATUSES } from '../../../Constants';
import {
  setPractices,
  updatePracticeStatus,
  setEnroutedPractices,
} from '../../../redux/features/Practice';
import { setUserStatus, destroyUser } from '../../../redux/features/User';
import { toast } from 'material-react-toastify';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select, Toast as CustomToast } from '../../../Components';

const SelectStatus = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.userReducer.user);
  const practices = useSelector((state) => state.practicesReducer.practices);
  const [enroutedPractice] = useSelector(
    (state) => state.practicesReducer.enroutedPractices
  );
  /*
  This function returns filtered assigned
  and enrouted practices when state of practice
  order changes, and then we'll update data in redux
  */

  const updatePracticesData = () => {
    let tempData = JSON.parse(JSON.stringify(practices));
    let assignedPractices = [];
    let enroutedPracticesTemp = [];
    if (props.currentValue === 'En-route') {
      tempData.splice(enroutedPractice?.idx, 0, props.data);
      assignedPractices = [...tempData];
    } else {
      if (enroutedPractice) {
        tempData.splice(enroutedPractice?.idx, 0, enroutedPractice);
      }
      assignedPractices = [
        ...tempData.filter((item) => item.id !== props.data.id),
      ];
      let indexOf = tempData.findIndex((item) => item.id === props.data.id);
      enroutedPracticesTemp = [
        ...tempData
          .filter((item) => item.id === props.data.id)
          .map((item) => {
            return { ...item, idx: indexOf };
          }),
      ];
    }
    return [assignedPractices, enroutedPracticesTemp];
  };

  // Event Handler
  const handleChange = (e) => {
    let newStatus = '';
    if (props.currentValue === 'Assigned') {
      newStatus = 'en-route';
    } else if (props.currentValue === 'En-route') {
      newStatus = 'assigned';
    }
    const data = {
      userId: user?.id,
      order: {
        old_status: props.currentValue.toLowerCase(),
      },
      riders: {
        practice_id: props.data.id,
        status: e.target.value.toLowerCase(),
      },
    };

    // For toggling state of practice
    dispatch(updatePracticeStatus(data))
      .unwrap()
      .then(() => {
        const [assignedPractices, enroutedPractices] = updatePracticesData();
        dispatch(setPractices(assignedPractices));
        dispatch(setEnroutedPractices(enroutedPractices));
        dispatch(setUserStatus(newStatus));
      })
      .catch((err) => {
        if (
          err?.error === 'You need to sign in or sign up before continuing.'
        ) {
          toast(
            <CustomToast
              severity="warning"
              message="Your session has been expired"
            />,
            { closeButton: false }
          );
          dispatch(destroyUser());
          navigate('/login');
        }
      });
  };

  return (
    <Select
      options={PICKUP_STATUSES}
      value={props.currentValue}
      onChange={handleChange}
      IconComponent={() => null}
    />
  );
};
SelectStatus.propTypes = {
  currentValue: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};
export default SelectStatus;
